import { RootState } from '../store'

export const reportsSelector = (state: RootState) => {
  const { reports } = state

  return reports
}
